export default "__VITE_ASSET__Dm_6vo5R__"